import { useMixpanel } from 'react-mixpanel-browser';

export const  WebHook = () => {
   return useMixpanel();
}


